export default "__VITE_ASSET__0HmDjQ66__"